/**
 * Redux Store Configuration
 *
 * Central store for the entire Beacon application.
 * All slice reducers are registered here.
 */
import { configureStore } from '@reduxjs/toolkit';
import envReducer from './slices/env/envSlice';
import paymentReducer from './slices/payment/paymentSlice';
import fileReducer from './slices/file/fileSlice';
import executionReducer from './slices/execution/executionSlice';
import executionsByStatusReducer from './slices/executionsByStatus/executionsByStatusSlice';
import notificationReducer from './slices/notifications/notificationSlice';
import paymentDetailReducer from './slices/paymentDetail/paymentDetailSlice';

export const store = configureStore({
  reducer: {
    env: envReducer,
    payment: paymentReducer,
    file: fileReducer,
    execution: executionReducer,
    executionsByStatus: executionsByStatusReducer,
    notifications: notificationReducer,
    paymentDetail: paymentDetailReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
